// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._12l21wug{margin-inline-end:auto}\n._1e0c1ule{display:block}\n._1pfhidpf{margin-block-start:0}\n._6rth1ejb{margin-block-end:var(--ds-space-300,24px)}\n._ahbq1wug{margin-inline-start:auto}\n._c71l649k{max-height:var(--_zsxb2b)}\n._p12f163m{max-width:var(--_11x3y0)}", ""]);
// Exports
module.exports = exports;
